import { getProjectJsonUrl } from './getProjectJsonUrl';
import { getProjectFromJson } from '@/requests/project';

import type { IProject } from '@/types';

type ConfigureProjectResult = {
  project: IProject | null;
  jsonUrl: string | null;
};

/**
 * Configures the project from URL parameters.
 * Handles presetJsonUrl deeplinks only.
 * Note: presetId deeplinks are handled separately by usePresetDeeplink hook.
 */
const configureProject = async (): Promise<ConfigureProjectResult> => {
  const { jsonUrl } = getProjectJsonUrl();

  // If JSON URL is provided, load remote project
  if (jsonUrl) {
    const project = await getProjectFromJson(jsonUrl);
    return {
      project,
      jsonUrl,
    };
  }

  // Default: no pre-configured project
  return {
    project: null,
    jsonUrl: null,
  };
};

export { configureProject };
